import * as nookies from 'nookies';
import { useEffect } from 'react';
import { logRejectionsToSentry } from '../../Sentry';

const COOKIE_NAME = 'mbox';
const MAX_COOKIE_LENGTH = 1000;

/** On 2021-07-22 we had an issue where a bugged version of Adobe Target was setting very long (4kb+) cookies.
 * This component looks for and deletes such bugged cookies.
 */
export const TargetCookieFixer = () => {
  useEffect(() => {
    logRejectionsToSentry('Deleting buggy Target cookie', async () => {
      const mboxCookie = nookies.parseCookies()[COOKIE_NAME];

      if (typeof mboxCookie === 'string' && mboxCookie.length > MAX_COOKIE_LENGTH) {
        nookies.destroyCookie(null, COOKIE_NAME, {
          path: '/',
          domain: '.healthengine.com.au',
        });
      }
    });
  }, []);

  return null;
};
